import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { comboboxEmptyStateStyles } from './styles/combobox-empty-state.styles';
import type { ComboboxEmptyStatePropsInterface } from './types/combobox-empty-state.types';

/**
 * @since 10.0.0
 */
export const ComboboxEmptyState = forwardRef<HTMLDivElement, ComboboxEmptyStatePropsInterface>(
  (props: ComboboxEmptyStatePropsInterface, forwardedRef) => {
    const { className, css: cssProp, ...rest } = props;
    const styles = css(comboboxEmptyStateStyles, cssProp);
    return (
      <div
        ref={forwardedRef}
        data-c11n-component="Combobox.EmptyState"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      />
    );
  },
);

ComboboxEmptyState.displayName = 'Combobox.EmptyState';
